var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-text-center"},[(_vm.$store.state.logo)?_c('img',{staticClass:"logo",attrs:{"src":_vm.$store.state.logo,"alt":_vm.$store.state.brandName}}):_c('icon',{staticClass:"logo",attrs:{"icon":"user-circle","size":"8x"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }